import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./stores";

import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import "./axios";

import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
// import 'bootstrap'

import "primeicons/primeicons.css";

// Fontawesome 6.4.0
// https://fontawesome.com/v6/search?m=free

import "@fortawesome/fontawesome-free/css/all.min.css";
// import '@/assets/font-awesome/css/font-awesome.min.css'
import "@/assets/css/style.scss";

import "@/assets/css/all.min.css";
import "@/assets/css/app.css";
import "@/assets/css/responsive.css";
import "../node_modules/vanillajs-datepicker/sass/datepicker.scss";

// Vuetify
// https://next.vuetifyjs.com/en/getting-started/installation/
// https://github.com/vuetifyjs/vuetify/releases/tag/v3.0.0

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// https://www.npmjs.com/package/v-tooltip
// https://vuetifyjs.com/en/components/tooltips/
// import VTooltip from 'v-tooltip'

// https://floating-vue.starpad.dev/guide/
import floatingVue from "floating-vue";
import "floating-vue/dist/style.css";

const vuetify = createVuetify({
  components,
  directives,
});

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

createApp(App)
  .component("VueDatePicker", VueDatePicker)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(pinia)
  .use(floatingVue)
  .mount("#app");
